var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGerman1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "german 1",
    clipPath: "url(#clip0_1626_152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "36 Multicolor / Flag / mc_36_flag_germany"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mc_36_flag_Germany"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0.466675 10.1087C1.52626 12.9649 4.27501 15.0004 7.50001 15.0004C10.725 15.0004 13.4738 12.9649 14.5333 10.1087L7.50001 9.45703L0.466675 10.1087Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M7.50001 0C4.27501 0 1.52626 2.03542 0.466675 4.89167L7.50001 5.54333L14.5333 4.89125C13.4738 2.03542 10.725 0 7.50001 0Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M0.466671 4.89104C0.157198 5.72579 -0.000834137 6.60908 3.71685e-06 7.49937C-0.000883721 8.38979 0.15715 9.27325 0.466671 10.1081H14.5333C14.8429 9.27325 15.0009 8.38979 15 7.49937C15.0009 6.60896 14.8429 5.72554 14.5333 4.89062L0.466671 4.89104Z",
    fill: "#D80027"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerman1);
export default __webpack_public_path__ + "static/media/german 1.1649e32b5c5be079b31b77186c524088.svg";
export { ForwardRef as ReactComponent };